import { CurrencyConfig } from '@wbk/currency';

CurrencyConfig.init({
  exchangeApi: process.env.VITE_PUBLIC_EXCHANGE_API!,
});
